var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePageArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.21 90.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.99,25.82c-9.5-.52-28.04,5.65-45.88,25.19C43.27,31.47,24.73,25.3,15.22,25.82c-.77.04,0,1.38,0,1.38,12.88,3.58,28.67,16.34,45.86,37.25h.05c17.19-20.91,32.97-33.67,45.86-37.25,0,0,.77-1.34,0-1.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageArrow);
export default __webpack_public_path__ + "static/media/home_page_arrow.68c4f0c858e4640c3c2eb16ea16f1bc4.svg";
export { ForwardRef as ReactComponent };